module.exports = () => {
    const data = require('../../../data/global');

    return data;
}